import { v$ } from './helpers.js';
import $ from 'jquery';


export const burger = document.querySelector('.burger'),
	nav = document.querySelector('.navigation'),
	mob_top_nav = document.querySelector('.mob_top_nav'),
    body = document.querySelector('body'),
	close_menu = document.querySelector('.close_menu'),
	lvl1 = v$('.prevent'),
	lvl1Link = v$('.menu > .has-dropdown > a'),
	lvl2 = v$('.menu > .has-dropdown > .dropdown');

burger.addEventListener('click', (e) => {
	e.currentTarget.classList.add('open');
	nav.classList.add('open');
	mob_top_nav.classList.add('open');
	body.classList.add('overflow-hidden');
});
close_menu.addEventListener('click', (e) => {
	burger.classList.add('open');
	nav.classList.remove('open');
	nav.classList.remove('open_lvl2');
	mob_top_nav.classList.remove('open');
    body.classList.remove('overflow-hidden');
	lvl2.forEach( (ul) => {
		ul.classList.remove('open');
	});
});

lvl1Link.forEach( link =>{
	let getText = link.innerHTML;
	// let createElement = document.createElement('li');
	// createElement.classList.add('goBack');
	// createElement.textContent = getText;
	link.parentNode.querySelector('.dropdown').insertAdjacentHTML( 'afterbegin', `<li class="goBack">${getText}</li>`);
});


const goBack = v$('.goBack');
goBack.forEach( li => {
	li.addEventListener('click', (e) =>{
		e.currentTarget.parentNode.classList.remove('open');
		nav.classList.remove('open_lvl2');
	});
});

lvl1.forEach( link => {
	link.addEventListener('click', (e) =>{
		e.preventDefault();
		if(window.matchMedia("(max-width: 1050px)").matches){
			if(e.currentTarget.className != 'goBack'){
				e.currentTarget.parentNode.querySelector('.dropdown').classList.add('open');
				nav.classList.add('open_lvl2');
			}
		}
	});
});







window.addEventListener('resize', () => {
	if(window.innerWidth > 1000){
		burger.classList.remove('open');
		nav.classList.remove('open');
		nav.classList.remove('open_lvl2');
		mob_top_nav.classList.remove('open');
		lvl2.forEach( (ul) => {
			ul.classList.remove('open');
		});
	}else{

	}
});
